import logo from './logo.png';
import profile from './profile-img.jpg';
import goldServiceLogo from './servicioGoldSticker.png';

export const assets = {
    logo,
    profile,
    goldServiceLogo
}
